import React from 'react';
import { Route, Routes } from 'react-router-dom'
import HomeController from '../controllers/HomeController';
import DashBoardLayout from "./DashboardLayout";
import SidebarLayout from './SidebarLayout';
import ProfileController from '../controllers/ProfileController';
import CheckoutController from "../controllers/CheckoutController";
import AttractionDetailController from "../controllers/AttractionDetailController";
import LocationDetailController from "../controllers/LocationDetailController";
import ProductFilterController from "../controllers/ProductFilterController";
import ProductDetailController from "../controllers/ProductDetailController";
import WishListController from '../controllers/WishListController';
import BookingSuccessController from '../controllers/BookingSuccessController';
import BlogDetailController from '../controllers/BlogDetailController';
import BlogController from '../controllers/BlogController';
import BlogCategoryDetailController from '../controllers/BlogCategoryDetailController';
import BlogCategoryController from '../controllers/BlogCategoryController';
import BookingController from '../controllers/BookingController';
import PrivacyController from '../controllers/PrivacyController';
import LanguagePrefixRedirect from './LanguagePrefixRedirect';
// import LanguagePrefixRedirect from './LanguagePrefixRedirect';

export default function PrivateRoutes() {
    return (
        <Routes>
            {/* <Route path="/profile" element={<SidebarLayout />}>
                <Route path="/profile" element={<ProfileController />} />
                <Route path="/profile/favourites" element={<WishListController />} />
                <Route path="/profile/bookings/upcoming" element={<BookingController view="upcoming" />} />
                <Route path="/profile/bookings/past" element={<BookingController view="past" />} />
                <Route path="/profile/privacy" element={<PrivacyController/>} />
            </Route> */}
            <Route path="/:lang/profile" element={<SidebarLayout />}>
                <Route index element={<ProfileController />} /> {/* /:lang/profile */}
                <Route path="favourites" element={<WishListController />} /> {/* /:lang/profile/favourites */}
                <Route path="bookings/upcoming" element={<BookingController view="upcoming" />} />
                <Route path="bookings/past" element={<BookingController view="past" />} />
                <Route path="privacy" element={<PrivacyController />} />
                {/* Optional slug if needed */}
                {/* <Route path=":slug" element={<DynamicProfileSubpage />} /> */}
            </Route>
            {/* <Route path="*" element={<LanguagePrefixRedirect />} /> */}
            {/* <Route path="/" element={<DashBoardLayout />}>
                    <Route path="*" element={<HomeController />} />
                </Route> */}
            {/* <Route path="/" element={<DashBoardLayout />}>
                <Route path="/home" element={<HomeController />} />
                <Route path="/tour/:slug" element={<ProductDetailController />} />
                <Route path="/location/*" element={<LocationDetailController />} />
                <Route path="/product/:slug" element={<LocationDetailController />} />
                <Route path="/attraction/:slug" element={<AttractionDetailController />} />
                <Route path="/blog" element={<BlogController />} />
                <Route path="/blog/article/:slug" element={<BlogDetailController />} />
                <Route path="/blog/category" element={<BlogCategoryController />} />
                <Route path="/blog/category/:slug" element={<BlogCategoryDetailController />} />
                <Route path="/search" element={<ProductFilterController />} />
                <Route path="/checkout" element={<CheckoutController />} />
                <Route path="/booking-success/:id" element={<BookingSuccessController />} />
                <Route path="/" element={<HomeController />} />
                <Route path="*" element={<HomeController />} />
            </Route> */}
        </Routes>
    )
}